import Button from '@components/button'
import Fields from '@components/fields'
import { Row, Typography } from '@components'
import { StyleColumn } from '@components/styles'
import { Form, Formik } from 'formik'
import { StyleBackDropWrapper, StyleModalWrapper, StyleWrapper } from './style'
import { Constant } from '@utils'
import { Driver } from '@apis'
import { useState } from 'react'

const AdminDriverForm = ({ visible = false, setVisible }: any) => {
  const [loading, setLoading] = useState<boolean>(false)
  const initialValues = {
    name: '',
    phoneNo: '',
    address: '',
    status: '',
  }
  const submitHandler = async (values: any) => {
    setLoading(true)
    const payload = {
      name: values?.name,
      phoneNo: values?.phoneNo,
      address: values?.address,
      status: values?.status,
    }

    await Driver.create(payload)
      .then(() => {
        setVisible(false)
      })
      .catch(() => {})
      .finally(() => {
        setLoading(false)
      })
  }
  const onCancel = () => {
    setVisible(false)
  }
  return (
    <>
      {!!visible && (
        <StyleWrapper>
          <StyleBackDropWrapper>
            <StyleModalWrapper>
              <Formik
                initialValues={initialValues}
                onSubmit={submitHandler}
                enableReinitialize
              >
                {({ handleSubmit }) => {
                  return (
                    <Form onSubmit={handleSubmit}>
                      <StyleColumn>
                        <Typography
                          content="Add Driver Details"
                          variant="h4"
                          weigth={500}
                          size={20}
                        />
                        <Fields.Input
                          name="name"
                          label="Name"
                          placeholder="Enter Name"
                        />
                        <Fields.PhoneInput
                          name="phoneNo"
                          label="Phone Number"
                        />
                        <Fields.Input
                          name="address"
                          label="Address"
                          placeholder="Enter Address"
                        />
                        <Fields.DropDown
                          name="status"
                          label="Status"
                          placeholder="Select Status"
                          options={Constant.driverStatus.map((status) => {
                            return {
                              name: status,
                            }
                          })}
                          valueAsKey="name"
                          titleAsKey="name"
                        />

                        <Row
                          justifyContent="center"
                          colGap={20}
                          styleRow={{ marginTop: 20 }}
                        >
                          <Button
                            title="Cancel"
                            type="button"
                            onClick={onCancel}
                            styleButton="width:100px"
                            bg="grey300"
                            height={35}
                          />
                          <Button
                            loading={loading}
                            title="Ok"
                            onClick={handleSubmit}
                            styleButton="width:100px"
                            height={35}
                          />
                        </Row>
                      </StyleColumn>
                    </Form>
                  )
                }}
              </Formik>
            </StyleModalWrapper>
          </StyleBackDropWrapper>
        </StyleWrapper>
      )}
    </>
  )
}

export default AdminDriverForm
